import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadUserRights = () => get(`${url}/partners/rights`);

const userRightsLoad = {loadUserRights};

export default userRightsLoad;
